<template lang="pug">
span(v-show="isVisible")
  //- INSTÂNCIA REAL DO WIDGET...
  component(
    v-if="myTooltip.disabled"
    :is="component"
    v-bind="{ ...$props, ...$attrs }"
    v-on="$listeners"
  )

  v-tooltip(
    v-else
    bottom
    nudge-bottom="-20"
    :class="myTooltip.class",
    :color="myTooltip.color"
  )
    template(#activator="{ on, attrs }")
      span(
        v-bind="attrs"
        v-on="on"
      )

        //- INSTÂNCIA REAL DO WIDGET...
        component(
          :is="component"
          v-bind="{ ...$props, ...$attrs }"
          v-on="$listeners"
        )

    span
      span.text-md.font-weight-medium(
        v-if="myTooltip.title"
      )
        | {{ myTooltip.title }}

      br(v-if="myTooltip.title && myTooltip.text")

      span.font-weight-light(
        v-if="myTooltip.text"
      )
        | {{ myTooltip.text }}

</template>

<script>
import { hasRel } from '@/helpers/rels'
import widgets from "@/components/widgets"
import { selectClass, selectColor } from "@/helpers/styles"
import { solveExpressionProperty } from '@/helpers/expressions'

export default {
  inheritAttrs: false,

  components: {
    ...widgets,
  },

  props: {
    /**
     * Objeto contendo os valores e campos do contexto no qual o widget está
     * inserido para inferência de propriedades aplicadas em interpolação de
     * templates de texto.
     */
    context: Object,

    /**
     * Instância opcional de um campo do Paper.
     * @type {Keep.Paper.Design.Field}
     */
    field: Object,

    /**
     * Um dos tipos de dados suportados pelo Paper.
     * @type {Keep.Paper.Design.TypeNames}
     */
    dataType: String,

    /**
     * Diz se o componente suporta seleção de intervalo.
     * @type {Boolean}
     */
    allowRange: Boolean,

    /**
     * Opções disponíveis na caixa de seleção.
     * É esperado que o usuário escolha um dos itens da caixa.
     * @type {Keep.Paper.Design.DataSet}
     */
    dataSet: Object,

    /**
     * Determina que o campo deve ser mantido oculto.
     */
    hidden: Boolean,

    /**
     * Tipo do Widget, para forçar o uso de um widget diferente daquele auto-detectável.
     */
    type: String,
  },

  computed: {
    mySubtitle: (vm) => vm.getIt("subtitle"),

    myTooltip() {
      let tooltip = this.getIt("tooltip")
      if (typeof tooltip === "string") tooltip = { text: tooltip }
      return {
        disabled: !(tooltip?.title || tooltip?.text || this.mySubtitle),
        title: tooltip?.title,
        text: tooltip?.text || this.mySubtitle,
        color: tooltip?.color || selectColor(tooltip?.style),
        class: selectClass(tooltip?.style),
      }
    },

    isVisible() {
      return !this.field?.invisible
    },

    component() {
      if (this.field?.expression) {
        solveExpressionProperty(this.field, this.field, (this.context || {}))
      }

      if (this.type) {
        return `Widget${this.type}`
      }

      if (hasRel(this.field, "Space")) return "WidgetSpace"
      if (hasRel(this.field, "Markdown")) return "WidgetMarkdown"
      if (hasRel(this.field, "Label")) return "WidgetLabel"

      if (this.hidden || this.field?.hidden) return "WidgetHidden"
      if (this.dataSet || this.field?.dataSet) return "WidgetSelect"

      const isRowsPerPage = hasRel(this.field, "Limit")
      if (isRowsPerPage) return "WidgetRowsPerPage"

      const type = this.dataType || this.field?.dataType || "String"
      const allowRange = this.allowRange || this.field?.allowRange

      let name = `Widget${type}`
      if (allowRange) {
        name = `${name}Range`
      }

      const found = !!widgets[name]
      return found ? name : "WidgetUnknown"
    },
  },

  methods: {
    getIt(property) {
      return (
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      )
    },
    hasIt(property) {
      if (this.$props[property] === "") return true
      if (this.$attrs[property] === "") return true
      const value =
        this[property] ||
        this.$props[property] ||
        this.$attrs[property] ||
        this.field?.[property]
      return !!value
    },
  },
}
</script>
